<script>
import AppNavbar from '@/components/AppNavbar'
import ArticleCover from '@/components/ArticleCover'
import ArticleMore from '@/components/ArticleMore'
import shareMixin from '@/mixins/shares'

export default {
	name: 'Article4',
	components: {
		AppNavbar,
		ArticleCover,
		ArticleMore,
	},
	mixins: [shareMixin],
	head: {
		title: {
			inner: 'Откуда появился вирус и есть ли от него защита?'
		},
		meta: [
			{p: 'og:title', c: 'Афиша Zombie: откуда появился вирус'},
			{p: 'og:description', c: 'Все о истоках зомби-апокалипсиса и попытках его обуздать.' },
			{p: 'og:image', c: '/static/share/4.jpg'},
			{p: 'og:site_name', c: 'Афиша Zombie'},
		]
	},
}
</script>



<template>
<div class="article">
	<app-navbar />
	<article-cover video="articles/4/cover">
		<h2 slot="title">Вирусология</h2>
		<p slot="text">Откуда появился вирус и есть ли от него защита?</p>
	</article-cover>

	<section class="text start">
		<div class="inner">

			<h2>Термин «зомби» можно услышать от героев «Ходячих мертвецов» ровно столько же раз, сколько слово «мафия» в фильме «Крестный отец». То есть ноль. Герои «Ходячих мертвецов» не видели ни одного фильма про зомби и понятия не имеют, как противостоять изначальному вирусу. Но способы есть.</h2>

			<p>
				Сериал не спешит объяснять, откуда же взялась эпидемия. Единственная серьезная «утечка» произошла в конце первого сезона. В шестой серии герои добираются до Центра по контролю заболеваний в Атланте и знакомятся с ученым Эдвином Дженнером. Тот открывает им страшную тайну: патоген вируса, превращающий людей в «ходячих», уже каким-то образом есть в каждом человеке на Земле. Чтобы узнать это, Эдвину пришлось наблюдать за тем, как умирала и воскресала его собственная жена Кэндис. И вот что известно об эпидемии благодаря ее жертве.
			</p>

			<img class="article-image" src="../assets/articles/4/1.jpg">

			<p>
				Во-первых, патоген существует в двух видах — спящем и активном. Спящим заражены все, поэтому любой человек, умерший или погибший после вспышки эпидемии (но не до), через какое-то время восстанет из мертвых. А активным можно заразиться из-за укуса. Прочие контакты с кровью или, например, слюной «ходячих» к заражению, как правило, не приводят: к примеру, Шейн как-то раз порезался ножом, которым кромсал зомби, — и ничего.
				<br><br>
				Во-вторых, после смерти человека патоген реактивирует не весь мозг, а только его ствол — так что ожившие мертвецы могут ходить и кусаться, но книги читать не в состоянии. Поэтому для профилактики воскрешения очень важно уничтожить мозг зараженного человека. В противном случае мутация займет от 3 минут до 8 часов. Огромное количество мертвецов во вселенной сериала, к слову, не ходячие, а ползучие, потому что превращение происходит после остывания тела. А пока кровь теплая, другие зомби, как правило, успевают как следует обглодать новобранца, оставив его без рук или ног.
			</p>

			<img class="article-image" src="../assets/articles/4/2.jpg">

			<p>
				Создатель сериала Роберт Киркман в одном из интервью признался, что расстроен эпизодом в Центре по контролю заболеваний, и будь у него машина времени, он бы вернулся на семь лет назад и убрал из сценария не только откровение о патогене, но и намек на то, что ученые близки к разгадке тайны эпидемии. Чем меньше герои знают о внешнем мире, тем, по его словам, лучше.
				<br><br>
				Тем не менее у фанатов есть огромное количество теорий о том, откуда могла взяться болезнь.
				<br><br>
				Самая популярная теория гласит, что инфекция распространяется по воздуху (заражены все вокруг, но остается надежда на моряков-подводников и космонавтов), а в основе ее лежит модифицированный вирус бешенства — поэтому зараженным так хочется кусаться.
				<br><br>
				Другая теория построена на предположении о том, что виновник эпидемии — паразит, заставляющий организм-носитель распространять его споры. И у него даже есть реальный прототип в природе: гриб кордицепс однобокий, который превращает муравьев-древоточцев (Camponotus leonardi) в зомби. Гриб-паразит заставляет насекомое-носителя покинуть колонию и забраться на дерево, чтобы оттуда продолжать сеять споры своего хозяина. К концу этих трогательных отношений из головы муравья уже торчит плодовое тело гриба. Но с этой теорией есть одна нестыковка — такой паразит мог бы атаковать не только людей, но и животных — но те в мире «Ходячих мертвецов» и не думают восставать из мертвых.
			</p>

			<img class="article-image" src="../assets/articles/4/3.jpg">

			<p>
				Подобная избирательность вируса — повод для самых диких теорий: вроде того, что за вымиранием людей последует колонизация Земли инопланетянами или что все происходящее — промысел Бога. Есть и версия, что вся эпидемия — неудачный военный эксперимент, причем за пределами США все в порядке. Ее косвенно подтверждает в седьмом сезоне Юджин, когда признается Нигану, что работал в проекте «Геном человека», одной из целей которого было превращение существующих болезней в оружие массового поражения.
				<br><br>
				Как минимум одну из самых странных теорий Роберт Киркман опроверг лично: события сериала — не видение Рика, лежащего в коме после перестрелки на шоссе, которую нам показали в самой первой серии сериала.
			</p>

			<img class="article-image" src="../assets/articles/4/4.jpg">

			<p>
				Куда интереснее, впрочем, не искать причины эпидемии, а наблюдать за попытками людей самоорганизоваться и противостоять ей. Фанаты отметили, что сериал от сезона к сезону повторяет школьный курс истории человечества. Первый год «Ходячих» — типичный первобытный строй: каждый сам за себя, в пещерах перебои с электричеством, а снаружи ждут монстры. Второй сезон — история перехода от собирательства и охоты к земледелию, а скромная ферма Хершела на территории бывшей тюрьмы — потерянный аграрный рай. Губернатор с его полицейским государством в Александрии и сильной идеологией — это Римская империя, не выдержавшая нашествия варваров. За ее падением следуют Темные века — включая вспышку чумы в тюрьме, долгое время бывшей приютом для героев. В следующем сезоне есть аллегория на рост влияния церкви и т.д. и т.п.
				<br><br>
				Так сохраняется ли у людей надежда на выживание? Хотелось бы верить. И, быть может, нам намекнут на некоторые новые теории в восьмом сезоне, который стартует 23 октября на канале FOX.
			</p>

		</div>
	</section>

	<section class="text footer">
		<div class="inner">
			Смотреть сериал можно в «Интерактивном ТВ Ростелеком».
			<br>
			Если нашествие зомби застало вас не дома, подключайте опцию «Мультискрин» —<br>с ней весь контент будет доступен не только на экране телевизора,<br>но и <a href="https://moscow.rt.ru/inttv" target="_blank" onclick="ga('send', 'event', 'link', 'article', 'rostelekom')">на сайте itv.rt.ru</a> или на вашем мобильном устройстве.
		</div>
	</section>

	<div class="footer-share clearfix">
		<div class="title">Поделиться статьей</div>
		<a :href="shareFb" target="_blank" @click="shareClick('fb')"><i class="fa fa-facebook" aria-hidden="true"></i></a>
		<a :href="shareVk" target="_blank" @click="shareClick('vk')"><i class="fa fa-vk" aria-hidden="true"></i></a>
		<a :href="shareTg" target="_blank" @click="shareClick('tg')"><i class="fa fa-telegram" aria-hidden="true"></i></a>
		<a :href="shareTw" target="_blank" @click="shareClick('tw')"><i class="fa fa-twitter" aria-hidden="true"></i></a>
		<a :href="shareOk" target="_blank" @click="shareClick('ok')"><i class="fa fa-odnoklassniki" aria-hidden="true"></i></a>
	</div>

	<div class="devider"></div>

	<section class="text more">
		<div class="inner">Читайте также</div>
	</section>

	<article-more :ids="[6, 2, 3]" />


</div>
</template>



<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.article {
	background: #fff;
}

section {
	width: 96%;
	max-width: 1040px;
	margin: 0 auto;
}

section .inner {
	max-width: 740px;
}

section h2 {
	padding: 0;
	margin: 0;
	font-weight: normal;
	font-size: 20px;
	padding-bottom: 20px;
	line-height: 30px;
}

section h3 {
	padding: 0;
	margin: 0;
	font-family: @fontLava;
	font-size: 18px;
	font-weight: bold;
	line-height: 27px;
}

section p {
	padding: 0;
	margin: 0;
	font-family: @fontLava;
	font-size: 18px;
	font-weight: normal;
	line-height: 27px;
}

.start {
	padding-top: 40px;
}

.text {
	background: #fff;
}

.text a {
	color: @red;
}

.article-image {
	width: 100%;
	max-width: 740px;
	padding: 40px 0;
}

.footer {
	padding: 40px 0;
	font-weight: 400;
	font-style: italic;
	font-family: @fontLava;
	line-height: 27px;
	font-size: 18px;

	a {
		color: @red;
	}
}

.footer-share {
	width: 100%;
	max-width: 1040px;
	margin: 0 auto;

	.title {
		width: 260px;
		height: 60px;
		line-height: 60px;
		font-size: 13px;
		letter-spacing: 1.5px;
		text-align: center;
		text-transform: uppercase;
		color: #fff;
		background: @red;
		float: left;
	}

	a {
		width: 80px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		font-size: 20px;
		float: left;
		color: #fff;
		transition: opacity 200ms ease;
		background: #090909;
		transition: all 200ms ease;
		border-right: 1px solid #333333;
		box-sizing: border-box;
	}

	a:last-child {
		border-right: none;
	}

	a:hover {
		background: @red;
	}

}

.devider {
	width: 100%;
	height: 5px;
	background: #090909;
	margin-top: 60px;
}

.more {
	color: @red;
	font-size: 30px;
	height: 80px;
	line-height: 80px;
}







@media only screen
and (max-device-width: 640px),
only screen and (max-device-width: 736px),
only screen and (max-width: 480px) {


.footer-share {

	.title {
		display: none;
	}

	a {
		width: 20vw;
		height: 20vw;
		text-align: center;
		line-height: 20vw;
		font-size: 20px;
		float: left;
		color: #fff;
		transition: opacity 200ms ease;
		background: #090909;
		transition: all 200ms ease;
		border-right: 1px solid #333333;
		box-sizing: border-box;
	}

}

.devider {
	display: none;
}



}

</style>



// WEBPACK FOOTER //
// Article4.vue?41081c17